const ja ={
    navbar : {
        home : "ホーム",
        aboutMe : "プロフィール",
        education : "学歴",
        employment : "職歴",
        achievements : "業績",
        research    : "研究",
        projects : "プロジェクト",
        collab : "コラボレーション",
    },
    home : {
        desc : "皆さんこんにちは！僕のホームページへようこそ。エドゥアルド・イグレシアスです。このサイトは僕の個人プロジェクトの一つで、LinkedInに似たデジタルポートフォリオとして使用しています。ここでは、僕が一人か友達と作成した色んなプロジェクトや成果を共有していきます。連絡先情報などの詳細は、一番下の所へスクロールしてください。楽しんで下さい!",
        news : {
            hackathon : "トラックジョブのハッカソンの優秀賞を入賞",
            masterHandai : "大阪大学情報科学研究科入学",
            graduateHandai : "大阪大学基礎工学部卒業",
            mextMaster : "文部科学省奨学金を受け取った（修士）",
            cChannel : "C-Channelでウェブ開発の勤務開始",
            helloSensei : "Hello Senseiでインドネシア語の先生の勤務開始",
            wasabi : "森興産株式会社で翻訳者として勤務開始",
            headInternal : "PPI-ONの内部長になった",
            memberInternal : "PPI-ONの内部のメンバーになった。",
            bachelorHandai : "大阪大学基礎工学部入学",
            jlc : "東京外国語大学留学生日本語教育センター入学",
            mextBachelor : "文部科学省奨学金を受け取った（学部）",
            advancedRobotics : "Advanced Roboticsに論文が採択",
            robomech : "ROBOMECH 2025（山形）で発表",
            moneyForward : "マネーフォワードでインターンシップ開始",
        },
    },
    aboutMe : {
        aboutMe : "プロフィール",
        name : "名前",
        age : "年齢",
        nationality : "国籍",
        occupation : "職業",
        hobby : "趣味",
        language : "言語",
        interest : "興味",
        indonesia : "インドネシア",
        masterStudent : "大学院生"
    },
    education : {
        education : "学歴",
        westKalimantan : "西ボルネオ",
        westJawa : "西ジャワ",
        indonesia : "インドネシア",
        elementary_title : "Immanuel Elementary School",
        junior_title : "Immanuel Junior High School",
        senior_title : "Immanuel Senior High School",
        itb_title : "バンドン工業大学",
        handai_title : "大阪大学",
        jlc_title : "東京外国語大学留学生日本語教育センター",
        elementary : "小学校",
        junior : "中学校",
        senior : "高校",
        itb_desc : "学部. この大学で在学するのは数か月だけで、それからMEXTの奨学金をもらい、日本へ進学しました.",
        osaka : "大阪",
        tokyo : "東京",
        japan : "日本",
        jlc : "日本語学校. 日本の大学へ進学するための日本語学校.",
        handai_under : "学部",
        handai_master : "修士",
    },
    employment : {
        employment : "職歴",
        wasabi_title : "インドネシア語・英語・日本語の翻訳者",
        wasabi_loc : "森興産株式会社, 大阪, 日本",
        wasabi_desc : "インドネシア語、英語、日本語の間で記事やニュースやSNSのキャプションなどの翻訳をやっていました。ただし、大学のスケジュールが厳しいため、短期間のみになりました。",
        hello_title : "インドネシア語先生",
        hello_loc : "Hello Sensei, 日本",
        hello_desc : "インドネシア語で、さまざまな年齢層の日本人学生に教えています",
        web_title : "ソフトウェアエンジニア",
        web_loc : "C-channel. 東京, 日本",
        web_desc : "ReactとTypeScriptを使用してページを設計し、MongoDBとMySQLを使用してデータベースを管理することなど、ページを開発しています。",
        teamlab_title : "フロントエンドエンジニア",
        teamlab_loc : "チームラボ株式会社. 東京, 日本",
        teamlab_desc : "ReactとNext.jsを使ってページをデザインする。ページがスクロールされると追従するローカルナビゲーションを作成し、ページに表示されるデータを絞り込むする機能を追加する.",
        amazon_title : "Software Development Engineer Intern",
        amazon_loc : "アマゾン. 東京, 日本",
        amazon_desc : "Amazon AWSサービスを使って別のサービスを作成する方法を学ぶ機会を得て、同時にAmazonのリーダーシッププリンシプルについてより深く理解する",
        mf_title : "ソフトウェアエンジニア",
        mf_loc : "マネーフォワード. 東京, 日本",
        mf_desc : "フロントエンドおよびバックエンドの開発、ユニットテスト、結合テスト、E2Eテストの作成を担当."
    },
    month : {
        present : "現在",
        january : "1月",
        february : "2月",
        march : "3月",
        april : "4月",
        may : "5月",
        june : "6月",
        july : "7月",
        august : "8月",
        september : "9月",
        october : "10月",
        november : "11月",
        december : "12月",
    },
    achievements : {
        achievements : "業績",
        key : {
            name : "賞名",
            year : "受賞年",
            desc : "詳細",
        },
        hackathon_desc : "Track Jobから発行された賞で、2週間以内に行われた全体的なアイデア、実装、や発表に対して優れたチームに授与された賞です。",
        gakubusho_desc : "大阪大学基礎工学部のコースから４年間の成績優良者（単位数と成績）の１名に与える賞です",
        mextMaster_desc : "日本の文部科学省によって提供され、日本で学ぶ外国人学生を支援します。授業料をカバーし、毎月の給付金を提供し、日本への往復旅費も含まれています",
        tpbsho_desc : "大阪大学全学教育優秀賞は、「教養」を中心に優れた学業成績を収めた学生を表彰する制度で, 毎年度全学部 50名程度（全学部入学定員 3,255名）です",
        mextBach_desc : "日本の文部科学省によって提供され、日本で学ぶ外国人学生を支援します。授業料をカバーし、毎月の給付金を提供し、日本への往復旅費も含まれています",
        other_desc : "小学校から高等学校までの間に受賞したその他の賞です。すべては写真で示されます。"
    },
    research : {
        research : "研究",
        detail : "詳細ヘ"
    },
    project : {
        title : "プロジェクト",
        key : {
            name : "プロ名",
            year : "開発年",
            desc : "詳細",
        },
        bi_name : "Bad Interface",
        bi_desc : "悪いインターフェースのアイデア: ログインページで名前はスクロールバーを使って設定し、PINはロシアンルーレットを使って設定できる。",
        hp_name : "Homepage",
        hp_desc : "自分のホームページ。LinkedInのようにデジタルポートフォリオとして使っています。このサイトは、自分のスタイルで作り、自分の実績や、自分で作った様々なプロジェクトを紹介していきます.",
        todo_name : "To-Do-List Android App",
        todo_desc : "ToDoリストのアンドロイドアプリ。ユーザーは自分の日付とやるべき作業を入力し、アプリに表示されます。作業が終わると、ユーザーはそのアクティビティを削除することもできます。このプロジェクトはアプリ開発への一歩として作られました。",
        calculator_name : "Calculator Web Service",
        calculator_desc : "簡単な計算ができる電卓のウェブサービスです。このプロジェクトは、ウェブ開発への一歩として作成されました.",
    },
    collab : {
        title : "コラボレーション",
        key : {
            name : "プロ名",
            year : "開発年",
            desc : "詳細",
        },
        image_name : "Automatic Image Cropper",
        image_desc : "画像を入力とし、その画像の中の主要な四角形のオブジェクトを即座に切り取り、新しい画像として出力するコンピュータビジョンのプログラムです.協力者 : 西田 直生、忠谷 晃佑、北村 祐稀",
        vr_name : "脱出迷路",
        vr_desc : "1対1のVRゲームです。一人のプレイヤーはゲームマスターとして、コンピュータで迷路を制御します。対戦プレイヤーはVR HMDを被り、迷路から脱出するプレイヤーの役割をしてます。VRプレイヤーの目的は、制限時間内に鍵や様々なアイテムを集めながら迷路から脱出して、その間、ゲームマスターが仕掛けた罠を避けつつ、迷路に潜むモンスターから逃れなければなりません。協力者 : 西滉平、年藤悠歩、佐山幸翼、玉置文人.",
        hackathon : "ユーザーが旅行に行ったときに領収書をスキャンし、他の人と割り勘できるモバイルアプリ。協力者 : 西 滉平, 吉崎 響, 和坂 優佑, 丸山 結, Buamanee Thanpimon.",
        ivrc : "ユーザーが絵の中に入り、提供されたオブジェクトを使って絵の世界の中で描くことができるVRプロジェクト. 協力者 : Junshu An, Buamanee Thanpimon, Toma Oya, Lee Gayeon, Chou",
        uroom : "部屋予約ウェブシステム. 今後のシステムの向上のため、このシステムはフロントエンド、バックエンド、データベースに分けられます. 協力者： Junshu An."
    },
    footer : {
        contact : "連絡先",
        professional : "プロフェッショナルSNS",
        personal : "パーソナルSNS",
        credits : "参考"
    }
}

export default ja;